module.exports = {
  localeName: 'fr-FR',
  momentFormat: 'DD/MM/YYYY'
};
